import { API_URL } from "../config/api";

async function readJson(res) {
  return res.json().catch(() => ({}));
}

export async function fetchGroupementsCatalog() {
  const res = await fetch(`${API_URL}/groupements`);
  const json = await readJson(res);
  if (!res.ok) {
    throw new Error(json.message || "Impossible de charger les groupements thématiques.");
  }
  return {
    items: Array.isArray(json.items) ? json.items : [],
    affiliations: Array.isArray(json.affiliations) ? json.affiliations : [],
  };
}

export async function fetchGroupements() {
  const { items } = await fetchGroupementsCatalog();
  return items;
}

export async function createGroupement({ title, color }) {
  const res = await fetch(`${API_URL}/groupements`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title, color }),
  });
  const json = await readJson(res);
  if (!res.ok) {
    throw new Error(json.message || "Impossible de créer le groupement thématique.");
  }
  return json.groupement;
}

export async function deleteGroupement(groupementId) {
  const res = await fetch(`${API_URL}/groupements/${encodeURIComponent(groupementId)}`, {
    method: "DELETE",
  });
  const json = await readJson(res);
  if (!res.ok) {
    throw new Error(json.message || "Impossible de supprimer le groupement thématique.");
  }
  return json;
}

export async function fetchGroupementMots(groupementId) {
  const res = await fetch(
    `${API_URL}/groupements/${encodeURIComponent(groupementId)}/mots`
  );
  const json = await readJson(res);
  if (!res.ok) {
    throw new Error(json.message || "Impossible de charger les mots du groupement.");
  }
  const mots = Array.isArray(json.mots) ? json.mots : [];
  return mots.map((item) =>
    typeof item === "string" ? { mot: item } : item
  );
}

export async function updateGroupement(groupementId, { title, color }) {
  const res = await fetch(`${API_URL}/groupements/${encodeURIComponent(groupementId)}`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ title, color }),
  });
  const json = await readJson(res);
  if (!res.ok) {
    throw new Error(json.message || "Impossible de modifier le groupement thématique.");
  }
  return json.groupement;
}

export async function emptyGroupement(groupementId) {
  const res = await fetch(
    `${API_URL}/groupements/${encodeURIComponent(groupementId)}/vider`,
    { method: "POST" }
  );
  const json = await readJson(res);
  if (!res.ok) {
    throw new Error(json.message || "Impossible de vider le groupement thématique.");
  }
  return json;
}

export async function removeWordsFromGroupement(groupementId, mots = []) {
  const res = await fetch(
    `${API_URL}/groupements/${encodeURIComponent(groupementId)}/retirer`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ mots }),
    }
  );
  const json = await readJson(res);
  if (!res.ok) {
    throw new Error(json.message || "Impossible de retirer ces mots du groupement.");
  }
  return json;
}

export async function reassignWordsFromGroupement(groupementId, affectations = []) {
  const res = await fetch(
    `${API_URL}/groupements/${encodeURIComponent(groupementId)}/reaffecter`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ affectations }),
    }
  );
  const json = await readJson(res);
  if (!res.ok) {
    throw new Error(json.message || "Impossible de réaffecter ces mots.");
  }
  return json;
}

export async function assignWordGroupement(mot, groupementId) {
  const res = await fetch(`${API_URL}/mots/${encodeURIComponent(mot)}/groupement`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ groupementId: groupementId || null }),
  });
  const json = await readJson(res);
  if (!res.ok) {
    throw new Error(json.message || "Impossible d'associer le mot à ce groupement.");
  }
  return json.mot;
}
